export const ALARM_CATEGORIES_LOAD = 'ALARM_CATEGORIES_LOAD';
export const ALARM_CATEGORIES_LOAD_SUCCESS = 'ALARM_CATEGORIES_LOAD_SUCCESS';
export const ALARM_CATEGORIES_LOAD_ERROR = 'ALARM_CATEGORIES_LOAD_ERROR';